export const filingTypes = [
  { label: 'Initial report', value: 'initial' },
  { label: 'Correct/amend prior report', value: 'amend' },
  { label: 'FinCEN directed Backfiling', value: 'backfiling' }
]
